// src/lib/axios.ts - Authenticated axios instance
import axios from 'axios';
import { getCloudPrepperBaseUrl, DEV_AUTH_BYPASS_ENABLED, DEV_AUTH_BYPASS_TOKEN } from '../src/config/env';
import { AUTH_SESSION_EXPIRED_EVENT } from '../src/contexts/AuthContext';
import { safeLocalStorage } from '../src/utils/storage';

// Create an axios instance with base configuration
const apiClient = axios.create({
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor to attach auth token
apiClient.interceptors.request.use(
    (config) => {
        config.baseURL = config.baseURL ?? getCloudPrepperBaseUrl();
        const token =
            sessionStorage.getItem('auth_token') ?? safeLocalStorage.getItem('auth_token');

        const effectiveToken = token || (DEV_AUTH_BYPASS_ENABLED ? DEV_AUTH_BYPASS_TOKEN : '');

        if (effectiveToken) {
            config.headers.Authorization = `Bearer ${effectiveToken}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Add response interceptor to handle auth errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid
            console.error('Authentication failed - token may be expired');

            if (!DEV_AUTH_BYPASS_ENABLED) {
                sessionStorage.removeItem('auth_token');
                sessionStorage.removeItem('auth_user');
                safeLocalStorage.removeItem('auth_token');
                safeLocalStorage.removeItem('auth_user');
                window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT));
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
